import React, { useCallback, useMemo } from 'react';
import { DeepLink, Gradient } from 'utils/types';
import { getReturnToGameLinkAddress, sendMessageToIframeParent } from './utils';
import { ECheckoutPageEvent } from 'utils/enums';
import { ActionButton } from 'components/ActionButton';

interface BackToGameButtonProps {
  btnText?: string;
  btnColor: Gradient;
  useNewCheckout: boolean;
  deepLinks?: DeepLink[];
  border?: string;
  borderRadius?: string;
  width?: string;
  marginTop?: string;
  marginBottom?: string;
}

export const BackToGameButton: React.FC<BackToGameButtonProps> = ({
  btnText,
  btnColor,
  deepLinks,
  border,
  useNewCheckout,
  borderRadius,
  width,
  marginTop,
  marginBottom,
}) => {
  const returnToGameLinkAddress = useMemo(
    () =>
      deepLinks && deepLinks.length > 0
        ? getReturnToGameLinkAddress(deepLinks)
        : '',
    [deepLinks],
  );

  const returnToGame = useCallback(() => {
    if (!returnToGameLinkAddress) return;

    if (useNewCheckout) {
      sendMessageToIframeParent(ECheckoutPageEvent.BACK_TO_GAME, {
        returnToGameLinkAddress,
      });
    } else {
      window.location.assign(returnToGameLinkAddress);
    }
  }, [returnToGameLinkAddress]);

  if (!returnToGameLinkAddress || !btnText) return <></>;

  return (
    <ActionButton
      text={btnText}
      action={returnToGame}
      colors={btnColor}
      border={border}
      borderRadius={borderRadius}
      width={width}
      marginTop={marginTop}
      marginBottom={marginBottom}
    />
  );
};
